import forage from 'localforage'

export const fTable = forage.createInstance({
  name: 'crms-table',
  storeName: 'rsm',
  driver: [
    forage.INDEXEDDB,
    forage.LOCALSTORAGE
  ]
})

const storageKey = 'area-managers-r-other-events'

const setTableOptions = ({ currentPage, perPage, sortBy, sortDesc, filter, totalRows }) => {
  return fTable.setItem(storageKey, {
    currentPage,
    perPage,
    sortBy,
    sortDesc,
    totalRows,
    filter: {
      status: 'All',
      search: filter.search,
      month: filter.month,
      area: filter.area,
      areaManager: filter.areaManager,
      activity: filter.activity
    }
  })
}

const getTableOptions = async () => {
  return await fTable.getItem(storageKey)
}

export {
  setTableOptions,
  getTableOptions
}
